import FieldDefs from './KeywordsFieldDefs'
import {doLangFields, isGoogleGny} from '../../../lib/ks-tools'
import KeywordsGny from "./KeywordsGny";

export default {
    template: `<div><slot v-bind="self"/></div>`,
    props: ["isDemo"],
    data() {
        return {
            fields: this.getTableFields(),
            sortOrder: [
                {
                    field: 'weight',
                    direction: 'desc'
                },
                {
                    field: window.report_db.engine === "yandex" ? 'wsk' : 'ws',
                    direction: 'desc'
                }
            ],
            additionalActions: [
                {
                    label: this.$t("lang.group_report.open_uniq_tools"),
                    icon: ["fa", "fa-object-ungroup"],
                    event: function() {
                        let vars = {
                            filter: this.getQuery(),
                            from: 'gkeywords',
                            rid: this.$parent.$parent.$refs.ksTable.apiUrl.split("/")[5]
                        };

                        window.open('/' + window.locale + '/tools/unique#' + Object.keys(vars).map(key => `${key}=${encodeURIComponent(vars[key])}`).join('&'), '_blank');
                    }
                },
            ],
        }
    },
    computed: {
        self() {
            return this;
        }
    },
    methods: {
        getTableFields() {
            let fields = doLangFields(this, "lang.group_report.keywords", isGoogleGny() ? KeywordsGny : FieldDefs);
            if (this.isDemo) {
                fields.shift();
            }

            return fields;
        }
    },
}
